import React, { useEffect } from 'react';
import cx from 'classnames';
// components
import MultiSelectBox from '@/components/MultiSelectBox';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Checkbox } from '@swiggy-private/dls-web-core/dist/components/Checkbox';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//stores
import useSearchCampaignStore from '@/stores/SearchCampaign';
import styles from './Filters.module.scss';
const CampaignName = ({ campaigns }) => {
    const [availableCampaignOptions, setAvailableCampaignOptions] = React.useState(() => campaigns);
    const { selectedOptions, setSelectedOptions } = useSearchCampaignStore((state) => ({
        selectedOptions: state.campaignFilter.selectedCampaigns,
        setSelectedOptions: state.campaignFilter.setSelectedCampaigns,
    }));
    useEffect(() => {
        setAvailableCampaignOptions(campaigns);
    }, [campaigns]);
    const renderFunction = (option, _, onClick, className) => {
        const onChange = (e) => {
            onClick(e);
        };
        return (React.createElement("div", { className: cx(className) },
            React.createElement("div", { className: styles.campaignText },
                React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, option.item.name),
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Reg, color: DlsColorTokens.text_Med_Emphasis }, option.item.id)),
            React.createElement("span", { onMouseDown: onChange },
                React.createElement(Checkbox, { label: "", orientation: "rtl", id: option.id, checked: option.selected }))));
    };
    const onChange = (options) => {
        const selectedOptionsValue = options
            .filter((option) => option.selected)
            .map((option) => option.item.id);
        const selectedPreselectedValue = [];
        const selectedValue = [];
        for (const val of selectedOptions) {
            const matchedItem = options.find((item) => item.id === val);
            if (matchedItem) {
                matchedItem.selected && selectedPreselectedValue.push(val);
            }
            else {
                selectedPreselectedValue.push(val);
            }
        }
        selectedOptionsValue.forEach((option) => {
            const isIncluded = selectedPreselectedValue.includes(option);
            if (!isIncluded) {
                selectedValue.push(option);
            }
        });
        const ids = [...selectedValue, ...selectedPreselectedValue];
        setSelectedOptions(ids);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: styles.filterLabel, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, "Campaign Name or ID"),
        React.createElement("div", null,
            React.createElement(MultiSelectBox, { openOnFocus: true, autoUpdatePosition: true, selectAllLabel: 'Campaigns', renderFunction: renderFunction, onChange: onChange, values: selectedOptions, options: availableCampaignOptions, identifier: (item) => item.id, onInputTextChange: (text) => {
                    const filteredOptions = campaigns.filter((campaign) => campaign.name
                        .toLowerCase()
                        .includes(text.toLowerCase()) ||
                        campaign.id === text);
                    setAvailableCampaignOptions(filteredOptions);
                } })),
        !!selectedOptions.length && (React.createElement("div", { className: styles.selectedCount },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Low_Emphasis },
                selectedOptions.length,
                " campaigns selected")))));
};
export default CampaignName;
